<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6">
        <div class="pa-3">
          <v-card-title>
            <v-text-field
              v-model="search"
              color="#86bc3a"
              append-icon="mdi-magnify"
              label="ค้นหา"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="partnerHeader"
            :items="all_partner"
            :footer-props="footer_Props"
            :search="search"
            mobile-breakpoint="0"
          >
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.item.customer_code }}</td>
                <td>{{ dataDetail.item.store_name }}</td>
                <td>{{ dataDetail.item.tel }}</td>
                <td>
                  <v-btn
                    small
                    height="42"
                    class="pos-main-bg white--text mr-1 mb-1"
                    title="ดูบิลย้อนหลัง"
                    @click="
                      $router.push(
                        '/storeinformationinvoice/' + dataDetail.item.id
                      )
                    "
                  >
                    ดูบิลย้อนหลัง
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
// import Swal from "sweetalert2";
import { HTTP } from "@/axios.js";
// import { HTTP_ARIN } from "@/axios_arin.js";
import { isTelephone, onPaste, validateEmail } from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "StoreInformation",
  data() {
    return {
      loading_page: false,
      loading_modal: false,
      add_partner: false,
      search: null,
      modal_details: false,
      modal_edit: false,
      modal_delete: false,
      alert_success: false,
      alert_reset: false,
      disabled_status: false,
      login_focus: false,
      emailRules: [
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "อีเมลไม่ถูกต้อง !",
      ],
      phoneRules: [(v) => v.length > 8 || "เบอร์โทรศัพท์ไม่ถูกต้อง !"],
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        "items-per-page-text": "รายการต่อหน้า",
      },
      partner_morg: {
        id: null,
        name: "บจ. ซิลลิค ฟาร์มา",
        telephone: "0854852359",
        email: "phama_plus@gmail.com",
      },
      partner_add: {
        id: null,
        code: null,
        name: null,
        telephone: "",
        email: "",
      },
      partner_get: {
        id: null,
        code: null,
        name: null,
        telephone: "",
        email: "",
      },
      partnerHeader: [],
      all_partner: [],
      cancel_bill: false,
      cancel: {
        part_id: null,
        password: null,
      },
    };
  },
  methods: {
    isNumber: function (evt, number) {
      return isTelephone(evt, number);
    },
    isEmail: function (evt) {
      return validateEmail(evt);
    },
    isPaste: function (evt) {
      return onPaste(evt);
    },
    async page() {
      this.partnerHeader = [
        {
          text: "รหัสสาขา",
          value: "customer_code",
          fixed: true,
          width: "125px",
        },
        {
          text: "ชื่อสาขา",
          value: "name",
          fixed: true,
          width: "450px",
        },
        {
          text: "เบอร์โทร",
          value: "telephone",
          fixed: true,
          width: "125px",
        },
        {
          text: "POS",
          value: "",
          sortable: false,
          fixed: true,
          width: "200px",
        },
      ];
      this.getCustomer();
    },
    checkLoading() {
      this.loading_page = true;
      HTTP.get("/customers/storelist").then((res) => {
        if (res.data.success === true) {
          this.loading_page = false;
          this.all_partner = res.data.object;
        }
      });
    },

    getCustomer() {
      HTTP.get("/customers/storelist").then((res) => {
        if (res.data.success === true) {
          this.all_partner = res.data.object;
        }
      });
    },

    checkLogIn() {
      if (this.$store.state.access_token === null) {
        this.$store.commit("logout_success");
        this.$router.push("/login");
      } else if (
        this.$store.state.userDetail.manage_partner_list == 0 &&
        this.$store.state.userDetail.manage_partner_create == 0 &&
        this.$store.state.userDetail.manage_partner_edit == 0 &&
        this.$store.state.userDetail.manage_partner_delete == 0
      ) {
        this.$router.push("/retailer");
      }
    },
  },
  beforeMount() {
    this.checkLogIn();
    this.checkLoading();
  },
  mounted() {
    this.page();
  },
};
</script>

<style scoped>
.pos-main-bg {
  background-color: #957e5d !important;
  color: #fff;
}

.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_flex {
  display: flex;
}

@media only screen and (max-width: 500px) {
  .grid_flex {
    display: grid;
  }

  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .btn_mobile {
    width: 100%;
  }
}
</style>
